import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { ThemeProvider } from '@mui/material/styles';
import { muiTheme } from './styles/muiTheme';
import ErrorBoundary from './components/ErrorBoundary';
import HomePage from './pages/HomePage';
import AccessibilityPage from './pages/AccessibilityPage';
// import TermsPage from './pages/TermsPage';
import WebsiteTermsPage from './pages/WebsiteTermsPage';
import PaymentPage from './pages/PaymentPage';
import PaymentSuccessPage from './pages/PaymentSuccessPage';

function App() {
  return (
    <ThemeProvider theme={muiTheme}>
      <ErrorBoundary>
        <Router>
          {/* Skip to Main Content - נגישות מקלדת */}
          <a href="#main-content" className="skip-to-main">
            דלג לתוכן הראשי
          </a>
          
          <div className="App">
            <Routes>
              <Route path="/" element={<HomePage />} />
              <Route path="/accessibility" element={<AccessibilityPage />} />
              {/* <Route path="/terms" element={<TermsPage />} /> */}
              <Route path="/website-terms" element={<WebsiteTermsPage />} />
              <Route path="/payment" element={<PaymentPage />} />
              <Route path="/payment-success" element={<PaymentSuccessPage />} />
            </Routes>
          </div>
        </Router>
      </ErrorBoundary>
    </ThemeProvider>
  );
}

export default App;
